// extracted by mini-css-extract-plugin
module.exports = {"primaryColorDark":"#070031","primaryColorLight":"#29234d","secondaryColor":"#fcffd3","textColorWhite":"#fff","textColorBlack":"#333"};